/**
 * SLIDER E KNOB · SKIN 2
 *
 * Segunda representação visual dos mesmos controles paramétricos.
 * A API continua sendo a mesma: skin é apenas mais uma opção do componente.
 */
export const slidersSkin2 = {
  legend: 'Slider e Knob · Skin 2',
  isGrid: true,
  rowspan: 4,
  content: [
    {
      element: 'slider',
      id: 'sliderV-skin2',
      label: 'Slider',
      skin: 2,
      display: true,
      style: { height: '280px' },
      value: 37,
      row: 0,
      col: 0,
      rowspan: 3,
      min: 0,
      max: 100,
      orient: 'vertical'
    },
    {
      element: 'slider',
      id: 'sliderH-skin2',
      label: 'Slider',
      skin: 2,
      display: true,
      style: { width: '280px' },
      value: 37,
      row: 0,
      col: 1,
      colspan: 2,
      min: 0,
      max: 100,
      orient: 'horizontal'
    },
    {
      element: 'knob',
      id: 'knob-pan-skin2',
      label: 'Pan',
      skin: 2,
      row: 1,
      col: 1,
      value: 0,
      display: true,
      scale: [-64, '', -32, '', 0, '', 32, '', 64]
    },
    {
      element: 'knob',
      id: 'knob-volume-skin2',
      label: 'Volume',
      skin: 2,
      row: 1,
      col: 2,
      value: 80,
      display: true
    }
  ]
};
